import React, { useEffect } from "react";

const Toast = ({ message, type = "error", onClose, duration = 5000 }) => {
  useEffect(() => {
    // Automatically close the toast after the specified duration
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    // Cleanup the timer when the component unmounts
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const styles = {
    container: {
      position: 'fixed',
      top: '10px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: type === "success" ? '#4CAF50' : '#F44336', // Green for success, red for error
      color: '#fff', // White text for both
      padding: '10px 20px',
      borderRadius: '4px',
      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      zIndex: 9999,
    },
    button: {
      background: 'none',
      border: 'none',
      color: '#fff',
      fontWeight: 'bold',
      marginLeft: '10px',
      cursor: 'pointer',
    }
  };

  return (
    <div style={styles.container}>
      <span>{message}</span>
      <button onClick={onClose} style={styles.button}>
        ✖
      </button>
    </div>
  );
};

export default Toast;